import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import BrowserBarOptionsStore from '../../stores/BrowserBarOptionsStore';
import { HelpButton } from '../../stores/BrowserBarOptions';
import Page from '../Fuse/Page';
import { Card } from '../Fuse';
import SnackStore from '../../stores/SnackStore';
import FuseButton from '../FuseControls/FuseButton';
import PagePreview from '../PagePreview/PagePreview';
import {
    BrandingOptionField,
    BrandingOptionView,
    HelpButtonActionField,
    HelpButtonActionView,
    HelpButtonField,
    HelpButtonView
} from './BrowserBarFields';
import BrowserBarPreview from './BrowserBarPeview';
import BrowserBarOptionsModal from './BrowserBarOptionsModal';
import { ROLE_READ_ONLY } from '../../stores/Administrators/AdministratorModalStore';
import ConsoleStore from '../../stores/ConsoleStore';

class BrowserBarOptionsPage extends Component {
    static propTypes = {
        snack: SnackStore.PropType.isRequired,
        console: ConsoleStore.PropType.isRequired,
        browserBarOptions: BrowserBarOptionsStore.PropType.isRequired,
    };

    componentWillMount() {
        this.props.browserBarOptions.load()
            .catch((e) => e && this.props.snack.showError(<span>Failed to load <b>Browser Bar</b>. {e.message}</span>));
    }

    render() {
        const { console, browserBarOptions: store } = this.props;
        const readOnly = console.authority === ROLE_READ_ONLY.value;

        return <Page title="Customize UI - Browser Bar">
            <Card
                title="Browser Bar"
                titleAction={readOnly ? null : <FuseButton
                    color="blue"
                    icon="edit"
                    onClick={store.openEditModal}
                    disabled={store.loadStatus.isFailed || store.loadStatus.isLoading}
                >Edit</FuseButton>}
                loading={store.loadStatus.isLoading}
            >
                {store.loadStatus.isLoading || store.loadStatus.isFailed ? null : <Fragment>
                    <BrandingOptionField>
                        {BrandingOptionView[store.brandingOption]}
                    </BrandingOptionField>
                    <HelpButtonField>
                        {HelpButtonView[store.helpButton]}
                    </HelpButtonField>
                    {store.helpButton !== HelpButton.DISABLED ? <HelpButtonActionField>
                        {HelpButtonActionView[store.helpButtonAction]}
                    </HelpButtonActionField> : null}
                    <PagePreview
                        pageComponent={BrowserBarPreview}
                        previewToggle={store.pagePreviewToggle}
                        headline="Browser Bar"
                        pageProps={{ browserBarOptions: { ...store } }}
                    />
                </Fragment>}
            </Card>

            <BrowserBarOptionsModal />
        </Page>;
    }
}

export default inject('console', 'browserBarOptions', 'snack')(observer(BrowserBarOptionsPage));
